export const SinglePlanOverViewInput = [
  {
    label: "Workout Name",
    type: "text",
    id: "workoutName",
    valueKey: "workoutName",
  },
  {
    label: "Workout Keywords",
    type: "text",
    id: "workoutKeywords",
    valueKey: "workoutKeywords",
  },
  {
    label: "Goal Orientation",
    type: "text",
    id: "goalOrientation",
    valueKey: "goalOrientation",
  },
  {
    label: "Training Type",
    type: "select",
    id: "trainingType",
    options: ["Strength", "Cardio", "Flexibility"],
    valueKey: "trainingType",
  },
  {
    label: "Sub-Category Count",
    type: "text",
    id: "subCategoryCount",
    valueKey: "subCategoryCount",
  },
  {
    label: "Workout Duration",
    type: "text",
    id: "workoutDuration",
    valueKey: "workoutDuration",
  },
  {
    label: "Location",
    type: "text",
    id: "location",
    valueKey: "location",
  },
  {
    label: "Calories Burned per Minute",
    type: "text",
    id: "caloriesBurnedPerMinute",
    valueKey: "caloriesBurnedPerMinute",
  },
  {
    label: "Video URL",
    type: "text",
    id: "videoUrl",
    placeholder: "Enter video URL",
    valueKey: "workout_video",
  },
  {
    label: "Image URL",
    type: "text",
    id: "bannerImageUrl",
    placeholder: "Enter image URL",
    valueKey: "banner_image",
  },
];
export const SinglePlanOverviewModalConfigInput = [
  {
    label: "Workout Name",
    type: "text",
    id: "workoutname",
    valueKey: "plan_name",
    disabled: true,
  },
  {
    label: "Duration",
    type: "text",
    id: "Duration",
    valueKey: "duration",
    disabled: true,
  },
  {
    label: "Level",
    type: "select",
    id: "Level",
    options: ["Beginner", "Intermediate", "Advanced"],
    valueKey: "level",
    disabled: true,
  },
  {
    label: "Location",
    type: "select",
    id: "Location",
    options: ["Gym", "Home", "Outdoor"],
    valueKey: "location",
    disabled: true,
  },
  {
    label: "Category",
    type: "select",
    id: "Category",
    options: ["Strength", "Cardio", "Flexibility"],
    valueKey: "trainingType",
    disabled: true,
  },
  {
    label: "Description",
    type: "textarea",
    id: "description",
    valueKey: "description",
    rows: 4,
    disabled: true,
  },
  {
    label: "Banner Image URL",
    type: "text",
    id: "bannerImageUrl",
    valueKey: "banner_image",
  },
  {
    label: "Video URL",
    type: "text",
    id: "videoUrl",
    valueKey: "plan_video",
  },
];
